var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngrenages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 225,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M185.367 133.113c1.431.733 3.231.06 4.018-1.504.787-1.564.265-3.425-1.168-4.159a2.638 2.638 0 0 0-.226-.1 18.22 18.22 0 0 0 .601-2.61c.082 0 .165-.001.249-.009 1.634-.147 2.93-1.662 2.896-3.382-.034-1.72-1.386-2.996-3.02-2.85-.085.009-.17.022-.253.036a16.932 16.932 0 0 0-.7-2.492 3.78 3.78 0 0 0 .223-.141c1.398-.987 1.845-2.936.998-4.354-.847-1.417-2.666-1.764-4.064-.777-.072.051-.139.106-.205.16a14.892 14.892 0 0 0-1.814-1.706 3.37 3.37 0 0 0 .132-.235c.787-1.564 1.816-3.272.373-3.982-3.339-1.643-4.771-.237-5.558 1.327a3.36 3.36 0 0 0-.11.246 14.564 14.564 0 0 0-2.436-.469c.005-.087.009-.174.007-.262-.034-1.72.471-2.652-1.168-2.684-3.576-.07-4.783 1.496-4.748 3.216.002.09.01.178.018.264-.82.236-1.624.538-2.407.901a2.916 2.916 0 0 0-.12-.228c-.847-1.417-2.665-1.764-4.064-.777-1.397.987-1.845 2.936-.998 4.354.044.072.091.14.139.207a18.17 18.17 0 0 0-1.734 2.028c-.07-.043-.14-.086-.214-.124-1.431-.734-3.231-.061-4.018 1.503-.787 1.564-.265 3.426 1.168 4.159.075.039.149.07.225.1a18.352 18.352 0 0 0-.6 2.61c-.082 0-.165.002-.249.01-1.634.146-2.931 1.661-2.897 3.381.034 1.721 1.387 2.997 3.021 2.85.085-.008.17-.02.252-.035.172.852.406 1.686.7 2.492-.074.044-.149.09-.222.141-1.398.987-1.845 2.936-.998 4.353.847 1.418 3.649 2.076 5.047 1.087.072-.05-.844-.415-.778-.471a14.883 14.883 0 0 0 1.813 1.706 3.358 3.358 0 0 0-.131.235c-.787 1.564-.265 3.425 1.167 4.159 1.431.733 3.231.06 4.018-1.504a3.54 3.54 0 0 0 .11-.245c.803.226 1.618.382 2.436.468-.005.087-.01.174-.007.262.034 1.72 1.387 2.997 3.02 2.85 1.634-.147 2.931-1.661 2.897-3.382-.001-.09-.01-.178-.018-.264.82-.236 1.625-.538 2.407-.901a3.3 3.3 0 0 0 .12.228c.847 1.417 2.666 1.764 4.064.777 1.397-.987 1.845-2.936.998-4.354a3.734 3.734 0 0 0-.139-.207 18.284 18.284 0 0 0 1.735-2.028c.069.044.14.086.213.124l-.001.002Zm-17.851.229c-5.199-2.662-7.097-9.423-4.238-15.1 2.858-5.678 9.389-8.122 14.588-5.46s7.097 9.422 4.238 15.1c-2.858 5.678-9.389 8.122-14.588 5.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M188.841 124.732c1.633-.146 2.93-1.661 2.896-3.381-.034-1.721-1.386-2.997-3.02-2.85-.086.008-.17.022-.253.036a16.945 16.945 0 0 0-.7-2.493c.075-.043.15-.09.223-.141 1.397-.987 3.126-3.373 2.141-4.695-1.872-2.508-3.809-1.422-5.206-.434a3.294 3.294 0 0 0-.205.16 14.82 14.82 0 0 0-1.814-1.706 3.306 3.306 0 0 0 .316-2.821 473.904 473.904 0 0 0-3.99 7.222c4.147 3.065 5.469 9.106 2.877 14.255-2.197 4.363-6.564 6.814-10.828 6.507-.19.497-.377.998-.581 1.49-.553 1.336-1.181 2.647-1.809 3.954.396.076.793.135 1.191.177a3.249 3.249 0 0 0-.007.262c.034 1.72 1.07 3.183 4.032 3.024 1.638-.088 1.919-1.836 1.885-3.556-.001-.09-.01-.178-.018-.265.82-.235 1.625-.537 2.408-.9.036.077.076.153.119.227.847 1.418 3.783 2.02 5.182 1.031 1.397-.987.727-3.191-.12-4.607a3.11 3.11 0 0 0-.139-.207 18.295 18.295 0 0 0 1.735-2.029c.069.044.14.087.213.125 1.431.734 3.231.06 4.018-1.504.787-1.564.265-3.425-1.168-4.158a2.238 2.238 0 0 0-.225-.1c.266-.865.466-1.737.601-2.61.081 0 .164-.002.248-.01l-.002-.003Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M186.906 133.29c1.432.733 3.231.06 4.018-1.504.787-1.564.265-3.425-1.167-4.159a2.638 2.638 0 0 0-.226-.1c.267-.865.466-1.736.601-2.61.081 0 .164-.001.249-.009 1.633-.147 2.93-1.662 2.896-3.382-.034-1.72-1.386-2.996-3.02-2.85-.086.009-.17.022-.253.036a16.932 16.932 0 0 0-.7-2.492 3.78 3.78 0 0 0 .223-.141c1.397-.987 1.845-2.936.998-4.354-.847-1.417-2.666-1.764-4.064-.777-.072.051-.139.106-.206.16a14.81 14.81 0 0 0-1.813-1.706c.046-.077.091-.154.132-.235.787-1.564.265-3.425-1.168-4.158-1.431-.734-3.23-.061-4.017 1.503a3.372 3.372 0 0 0-.111.246 14.533 14.533 0 0 0-2.435-.469c.005-.087.009-.174.006-.262-.034-1.72-1.386-2.996-3.02-2.85-1.634.147-2.93 1.662-2.896 3.382.001.09.009.178.017.264a16.76 16.76 0 0 0-2.407.901 3.289 3.289 0 0 0-.119-.228c-.847-1.417-2.666-1.764-4.065-.777-1.397.987-1.844 2.936-.997 4.354.043.072.091.14.138.207a18.383 18.383 0 0 0-1.734 2.028 3.198 3.198 0 0 0-.213-.124c-1.432-.734-3.231-.061-4.018 1.503-.787 1.564-.265 3.426 1.167 4.159.075.039.15.07.226.1a18.494 18.494 0 0 0-.601 2.61c-.081 0-.164.002-.249.01-1.633.147-2.93 1.661-2.896 3.382.034 1.72 1.386 2.996 3.02 2.849.086-.008.17-.02.253-.035.171.852.405 1.686.7 2.492-.075.044-.15.09-.223.141-1.397.987-1.844 2.936-.998 4.353.847 1.418 2.666 1.765 4.064.778.072-.051.139-.106.206-.161a14.814 14.814 0 0 0 1.813 1.707 3.808 3.808 0 0 0-.132.234c-.787 1.564-.265 3.426 1.168 4.159 1.431.733 3.231.06 4.018-1.504.04-.081.076-.163.11-.245.803.226 1.617.382 2.435.469a2.848 2.848 0 0 0-.006.262c.034 1.72 1.386 2.996 3.02 2.849 1.634-.146 2.93-1.661 2.896-3.381a3.247 3.247 0 0 0-.017-.265 16.756 16.756 0 0 0 2.407-.9c.037.076.076.153.12.227.846 1.417 2.665 1.764 4.064.777 1.397-.987 1.844-2.936.997-4.353-.043-.073-.091-.14-.138-.207a18.287 18.287 0 0 0 1.734-2.029c.069.044.14.087.213.125Zm-17.85.229c-5.199-2.662-7.097-9.423-4.238-15.1 2.858-5.678 9.389-8.122 14.588-5.46s7.097 9.422 4.238 15.1c-2.858 5.678-9.389 8.122-14.588 5.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M178.475 204.397c2.806 1.437 6.329.118 7.871-2.945 1.543-3.064.518-6.71-2.286-8.147a5.417 5.417 0 0 0-.442-.197 36.222 36.222 0 0 0 1.178-5.112c.16 0 .322-.002.486-.017 3.2-.288 5.74-3.253 5.674-6.624-.067-3.371-2.716-5.869-5.916-5.583a5.46 5.46 0 0 0-.495.071 33.026 33.026 0 0 0-1.37-4.881c.147-.086.294-.177.437-.278 2.737-1.934 3.613-5.753 1.954-8.528-1.658-2.775-5.222-3.457-7.959-1.523-.14.099-.272.206-.403.316a28.825 28.825 0 0 0-3.55-3.342c.09-.15.178-.3.258-.459 1.543-3.064 3.557-6.409.73-7.801-6.539-3.22-9.346-.464-10.887 2.599a6.205 6.205 0 0 0-.215.481 28.733 28.733 0 0 0-4.771-.919c.009-.17.018-.341.015-.514-.067-3.37.924-5.195-2.288-5.258-7.005-.137-9.368 2.929-9.301 6.3.004.177.018.348.035.52a32.444 32.444 0 0 0-4.716 1.765 5.907 5.907 0 0 0-.235-.445c-1.659-2.776-5.223-3.457-7.96-1.523-2.738 1.934-3.613 5.753-1.955 8.527.085.143.178.276.272.406a35.847 35.847 0 0 0-3.396 3.975 5.263 5.263 0 0 0-.419-.244c-2.806-1.436-6.329-.118-7.871 2.946-1.543 3.062-.518 6.71 2.286 8.146.145.074.293.137.443.198a35.929 35.929 0 0 0-1.177 5.111c-.161 0-.322.003-.487.018-3.201.288-5.74 3.254-5.673 6.625.066 3.37 2.715 5.869 5.915 5.581a5.41 5.41 0 0 0 .495-.071 33.026 33.026 0 0 0 1.37 4.881 5.829 5.829 0 0 0-.436.279c-2.738 1.934-3.613 5.753-1.955 8.527 1.658 2.776 7.148 4.064 9.886 2.13.14-.098-1.654-.814-1.524-.922a28.977 28.977 0 0 0 3.55 3.342c-.089.149-.178.3-.258.459-1.543 3.062-.518 6.71 2.286 8.146 2.806 1.437 6.329.118 7.872-2.946a7.07 7.07 0 0 0 .215-.481c1.574.443 3.168.75 4.77.919-.009.17-.017.341-.015.514.067 3.37 2.716 5.869 5.916 5.581 3.2-.287 5.74-3.252 5.673-6.623a6.278 6.278 0 0 0-.035-.519 32.505 32.505 0 0 0 4.717-1.766c.073.151.148.3.235.444 1.658 2.776 5.222 3.457 7.959 1.523 2.738-1.934 3.613-5.753 1.955-8.527a5.124 5.124 0 0 0-.272-.406 35.749 35.749 0 0 0 3.397-3.975c.136.086.273.17.418.244l-.001.002Zm-34.968.447c-10.184-5.214-13.902-18.457-8.302-29.578 5.599-11.121 18.393-15.909 28.578-10.694 10.185 5.214 13.902 18.457 8.302 29.578-5.598 11.121-18.393 15.909-28.578 10.694Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M185.279 187.978c3.2-.287 5.74-3.254 5.674-6.624-.067-3.371-2.716-5.87-5.916-5.582a5.388 5.388 0 0 0-.494.071 33.272 33.272 0 0 0-1.37-4.881c.146-.086.293-.177.436-.278 2.737-1.934 6.125-6.609 4.193-9.198-3.666-4.914-7.461-2.787-10.198-.853-.14.099-.272.206-.403.316a28.825 28.825 0 0 0-3.55-3.342c.09-.15.178-.3.258-.46.839-1.666.914-3.505.359-5.067a912.917 912.917 0 0 0-7.815 14.147c8.124 6.004 10.71 17.837 5.632 27.924-4.303 8.548-12.858 13.348-21.211 12.747-.372.974-.738 1.954-1.137 2.919-1.084 2.62-2.314 5.184-3.545 7.746.775.147 1.552.264 2.332.346-.009.17-.017.341-.015.514.067 3.37 2.096 6.234 7.896 5.924 3.208-.171 3.76-3.595 3.693-6.966a6.876 6.876 0 0 0-.035-.52 32.328 32.328 0 0 0 4.716-1.765c.074.151.149.3.236.444 1.658 2.776 7.41 3.955 10.148 2.021 2.737-1.935 1.424-6.251-.234-9.025a5.124 5.124 0 0 0-.272-.406 35.962 35.962 0 0 0 3.397-3.975c.136.086.273.17.418.244 2.806 1.436 6.329.118 7.872-2.946 1.541-3.062.518-6.71-2.287-8.146a5.566 5.566 0 0 0-.441-.198c.52-1.694.913-3.403 1.177-5.111.16 0 .322-.003.486-.018v-.002Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M181.491 204.743c2.806 1.437 6.329.118 7.872-2.945 1.542-3.064.518-6.71-2.287-8.147a5.555 5.555 0 0 0-.441-.197c.52-1.694.913-3.404 1.177-5.112.16 0 .322-.002.486-.018 3.2-.287 5.74-3.252 5.674-6.623-.067-3.371-2.716-5.87-5.916-5.583a5.388 5.388 0 0 0-.494.071 33.272 33.272 0 0 0-1.37-4.881c.146-.086.293-.177.436-.278 2.737-1.934 3.613-5.753 1.954-8.528-1.658-2.776-5.222-3.457-7.959-1.523-.14.099-.272.206-.403.316a28.825 28.825 0 0 0-3.55-3.342c.09-.15.178-.3.258-.46 1.543-3.063.518-6.709-2.286-8.146-2.805-1.436-6.328-.118-7.871 2.946a7.07 7.07 0 0 0-.215.481 28.609 28.609 0 0 0-4.771-.918c.01-.17.018-.342.015-.514-.067-3.371-2.716-5.87-5.915-5.582-3.2.288-5.74 3.253-5.674 6.623a6.3 6.3 0 0 0 .036.52 32.456 32.456 0 0 0-4.717 1.765 5.74 5.74 0 0 0-.235-.445c-1.658-2.776-5.222-3.457-7.96-1.523-2.737 1.934-3.613 5.753-1.954 8.527.084.143.178.276.271.406a35.847 35.847 0 0 0-3.396 3.975 5.09 5.09 0 0 0-.419-.244c-2.805-1.436-6.329-.118-7.871 2.946-1.543 3.064-.518 6.71 2.286 8.146.145.074.294.138.443.198a35.929 35.929 0 0 0-1.177 5.111c-.16 0-.322.003-.487.018-3.199.288-5.74 3.254-5.673 6.625.067 3.371 2.716 5.87 5.915 5.582.168-.015.332-.041.495-.072a33.161 33.161 0 0 0 1.37 4.882 6.025 6.025 0 0 0-.436.278c-2.738 1.934-3.613 5.753-1.955 8.527 1.659 2.776 5.222 3.457 7.96 1.523.14-.098.272-.205.402-.315a29.07 29.07 0 0 0 3.551 3.343c-.09.15-.178.3-.259.459-1.542 3.064-.517 6.71 2.287 8.147 2.805 1.436 6.328.118 7.871-2.946a7.07 7.07 0 0 0 .215-.481c1.574.443 3.168.75 4.771.918-.01.17-.018.342-.015.514.066 3.371 2.715 5.87 5.915 5.582 3.2-.288 5.74-3.253 5.674-6.623a6.804 6.804 0 0 0-.036-.52 32.5 32.5 0 0 0 4.717-1.765c.073.15.148.3.235.444 1.658 2.775 5.222 3.457 7.96 1.523 2.737-1.934 3.612-5.753 1.956-8.528a5.877 5.877 0 0 0-.274-.406 35.658 35.658 0 0 0 3.397-3.975c.136.087.273.17.419.244h-.002Zm-34.967.447c-10.185-5.214-13.903-18.457-8.303-29.578 5.599-11.121 18.394-15.909 28.578-10.695 10.185 5.215 13.903 18.458 8.303 29.579-5.599 11.12-18.394 15.908-28.578 10.694Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m50.033 83.373 4.72-.026S66.056 69.04 73.695 68.25l.708-40.306c-29.259.098-55.08 16.588-66.84 40.961l42.469 14.468v-.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M106.476 101.236c-2.399 13.243-14.46 23.655-29.234 24.114-3.637.114-7.878-2.067-7.878-2.067s-3.89.214-4.556-.045l-23.064 35.719c10.72 4.84 22.83 7.213 35.498 6.483 36.838-2.116 65.8-29.856 69.018-63.251l-39.784-.953Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m34.525 155.199 4.615.159 18.66-35.985c-6.961-5.157-11.436-13.18-11.436-22.282 0-2.198.264-4.342.76-6.406L9.116 76.335l-4.623.054A65.7 65.7 0 0 0 .967 97.648c0 24.506 13.442 45.605 33.56 57.548l-.002.003Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M81.76 68.426c13.455 2.003 23.8 12.433 25.029 25.323l65.056 1.886v-.082c0-.05 9.807-1.578 9.807-1.583C181.649 93.525 92.781.08 92.781.08L82.923 1.7s-.777 44.484-1.164 66.727h.001Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M54.687 83.373c4.711-8.245 13.478-14.068 23.663-15.122l.708-40.306c-29.259.098-55.08 16.588-66.84 40.961l42.469 14.468v-.001Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M111.13 101.235c-2.399 13.243-14.46 23.655-29.234 24.114-4.405.138-8.615-.623-12.434-2.113l-23.064 35.719c10.72 4.84 22.83 7.213 35.498 6.483 36.838-2.116 65.801-29.856 69.018-63.251l-39.784-.953v.001Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m39.18 155.199 23.275-35.825c-6.962-5.156-11.437-13.179-11.437-22.281 0-2.199.264-4.343.76-6.407L9.148 76.392A65.701 65.701 0 0 0 5.62 97.65c0 24.506 13.442 45.605 33.56 57.548Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M91.568 66.727c13.455 2.002 23.8 12.432 25.029 25.323l65.056 1.886v-.082c0-47.74-38.026-88.594-88.92-93.854l-1.165 66.728v-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M73.002 124.375a30.855 30.855 0 0 1-3.54-1.138L46.4 158.956c10.72 4.84 22.83 7.213 35.498 6.484 10.235-.588 19.86-3.157 28.497-7.272-8.717-1.32-16.5-4.628-22.715-10.138-7.08-6.278-11.671-15.011-14.675-23.655h-.002Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M65.26 43.943c-2.739-5.053-6.655-8.883-11.049-11.808-18.49 6.383-33.72 19.625-41.992 36.77l42.47 14.468c2.947-5.16 7.483-9.37 12.96-12.058 1.107-10.723 2.363-18.606-2.389-27.372Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 219.809,
    x2: 175.042,
    y1: 136.78,
    y2: 124.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 2.314,
    x2: 85.723,
    y1: 77.129,
    y2: 183.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 174.043,
    x2: 174.753,
    y1: 107.867,
    y2: 164.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 246.175,
    x2: 158.479,
    y1: 210.762,
    y2: 186.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 245.945,
    x2: 158.25,
    y1: 211.58,
    y2: 186.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 156.292,
    x2: 157.686,
    y1: 154.943,
    y2: 266.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 38.047,
    x2: 52.689,
    y1: 21.66,
    y2: 152.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 91.409,
    x2: 148.365,
    y1: 125.294,
    y2: 239.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 219.928,
    x2: 175.159,
    y1: 136.362,
    y2: 123.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 164.123,
    x2: 108.705,
    y1: 3.065,
    y2: 79.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 42.712,
    x2: 57.217,
    y1: 21.752,
    y2: 151.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 96.065,
    x2: 153.019,
    y1: 125.293,
    y2: 239.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 6.986,
    x2: 63.246,
    y1: 77.151,
    y2: 140.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 177.294,
    x2: 116.33,
    y1: -9.428,
    y2: 74.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 69.066,
    x2: 124.972,
    y1: 139.56,
    y2: 251.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 36.069,
    x2: 50.548,
    y1: 22.604,
    y2: 152.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngrenages);
export default __webpack_public_path__ + "static/media/engrenages.0191554fe8c9b242613b6d94fd7026c6.svg";
export { ForwardRef as ReactComponent };